import type { Style } from './types';
import type { SkinDefinition } from '@wix/editor-elements-panel/dist/adapters/types';

const pickPropsByKeyList = (
  props: Record<string, any> | undefined,
  keysList: Array<string>,
  createPrefixedPropertyName: (key: string) => string,
) => {
  if (!props) {
    return {};
  }
  return Object.fromEntries(
    keysList
      .map(key => [key, props[createPrefixedPropertyName(key)]])
      .filter(([_, value]) => value !== undefined),
  );
};
export const pickStyleProperties = (
  style: Style,
  propertiesList: Array<string>,
  createPrefixedPropertyName: (key: string) => string,
) => {
  const properties = pickPropsByKeyList(
    style.properties,
    propertiesList,
    createPrefixedPropertyName,
  );
  const propertiesOverride = pickPropsByKeyList(
    style.propertiesOverride,
    propertiesList,
    createPrefixedPropertyName,
  );
  const propertiesSource = pickPropsByKeyList(
    style.propertiesSource,
    propertiesList,
    createPrefixedPropertyName,
  );
  return {
    properties,
    propertiesOverride,
    propertiesSource,
  };
};
export const hasDetachedStyleProperties = (
  properties: Style['properties'],
  skinParams: SkinDefinition,
) => {
  const propertiesList = Object.keys(skinParams);
  return propertiesList.some(prop => {
    return properties[prop] !== undefined && properties[prop] !== 'initial';
  });
};
